import { useSelector } from 'react-redux';
import { featureToggleSelectors } from '@makemydeal/dr-shared-store';
import { useCustomerCardContext } from '../components/CustomerFormContext';
import { BUSINESS } from '../constants';
import * as customerCardSelectors from '../store/selectors';
import { useCustomerCardSelector } from './useCustomerCardSelector';

export const useIsChangeCustomerCtaVisible = (isLocked?: boolean): boolean => {
    const isChangeBuyerEnabled = useSelector(featureToggleSelectors.isChangeBuyerCoBuyerEnabled);
    const operation = useCustomerCardSelector(customerCardSelectors.getCardOperation);
    const buyer = useCustomerCardSelector(customerCardSelectors.getBuyer);
    const { capabilities } = useCustomerCardContext();

    return Boolean(
        isChangeBuyerEnabled &&
            capabilities?.enableChangeBuyerCoBuyer !== false &&
            !isLocked &&
            buyer?.customerType !== BUSINESS &&
            !operation
    );
};
